export default class ToggleButton {
  constructor() {
    this.toggleButtonSelector = "[data-js-button='toggle-button']";
    this.expandedClass = "js-expanded";
    this.hiddenClass = "js-hidden";

    this.toggleButtonArray = document.querySelectorAll(
      this.toggleButtonSelector
    );

    this.defaultEvent();
  }

  /**
   * Toggle aria-expanded true/false on button
   * @param {HTMLElement} targetButton button to execute method on
   */
  toggleAriaExpanded(targetButton) {
    const currentValue = targetButton.getAttribute("aria-expanded");
    targetButton.setAttribute(
      "aria-expanded",
      currentValue === "true" ? "false" : "true"
    );
  }

  toggleTitle(targetButton) {
    const currentValue = targetButton.getAttribute("title");
    targetButton.setAttribute(
      "title",

      currentValue === targetButton.getAttribute("data-closed-title")
        ? targetButton.getAttribute("data-opened-title")
        : targetButton.getAttribute("data-closed-title")
    );
  }

  toggleClasses(targetButton) {
    targetButton.classList.toggle(this.expandedClass);
  }

  toggleIconClasses(targetIcons) {
    const iconArray = Array.from(targetIcons);
    iconArray.forEach(targetIcon => {
      targetIcon.classList.toggle(this.hiddenClass);
    });
  }

  defaultEvent() {
    this.toggleButtonArray.forEach(toggleButton => {
      if (!toggleButton.hasEventListener) {
        toggleButton.addEventListener("click", event => {
          const currentButton = event.currentTarget;
          const buttonIcons = currentButton.getElementsByClassName("egat-icon");
          this.toggleAriaExpanded(currentButton);
          this.toggleTitle(currentButton);
          this.toggleClasses(currentButton);
          this.toggleIconClasses(buttonIcons);
        });
      }
      toggleButton.hasEventListener = true;
    });
  }
}

// Ensure the document is ready before instantiating the class
document.addEventListener("DOMContentLoaded", () => {
  new ToggleButton();
});
